"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var loadUserStandardBadges = function loadUserStandardBadges(payload) {
  return {
    type: 'LOAD_USER_STANDARD_BADGES',
    payload: payload
  };
};

var loadUserStandardBadgesSuccess = function loadUserStandardBadgesSuccess(userStandardBadges) {
  return {
    type: 'LOAD_USER_STANDARD_BADGES_SUCCESS',
    payload: {
      userStandardBadges: userStandardBadges
    }
  };
};

var loadUserStandardBadgesError = function loadUserStandardBadgesError(error) {
  return {
    type: 'LOAD_USER_STANDARD_BADGES_ERROR',
    payload: {
      error: error
    }
  };
};

var resetUserStandardBadges = function resetUserStandardBadges() {
  return {
    type: 'RESET_USER_STANDARD_BADGES'
  };
};

var loadUserAllBadges = function loadUserAllBadges(payload) {
  return {
    type: 'LOAD_USER_ALL_BADGES',
    payload: payload
  };
};

var loadUserAllBadgesSuccess = function loadUserAllBadgesSuccess(userAllBadges) {
  return {
    type: 'LOAD_USER_ALL_BADGES_SUCCESS',
    payload: {
      userAllBadges: userAllBadges
    }
  };
};

var loadUserAllBadgesError = function loadUserAllBadgesError(error) {
  return {
    type: 'LOAD_USER_ALL_BADGES_ERROR',
    payload: {
      error: error
    }
  };
};

var resetUserAllBadges = function resetUserAllBadges() {
  return {
    type: 'RESET_USER_ALL_BADGES'
  };
};

var loadUserRaceBadges = function loadUserRaceBadges(payload) {
  return {
    type: 'LOAD_USER_RACE_BADGES',
    payload: payload
  };
};

var loadUserRaceBadgesSuccess = function loadUserRaceBadgesSuccess(userRaceBadges) {
  return {
    type: 'LOAD_USER_RACE_BADGES_SUCCESS',
    payload: {
      userRaceBadges: userRaceBadges
    }
  };
};

var loadUserRaceBadgesError = function loadUserRaceBadgesError(error) {
  return {
    type: 'LOAD_USER_RACE_BADGES_ERROR',
    payload: {
      error: error
    }
  };
};

var resetUserRaceBadges = function resetUserRaceBadges() {
  return {
    type: 'RESET_USER_RACE_BADGES'
  };
};

var _default = {
  loadUserStandardBadges: loadUserStandardBadges,
  loadUserStandardBadgesSuccess: loadUserStandardBadgesSuccess,
  loadUserStandardBadgesError: loadUserStandardBadgesError,
  resetUserStandardBadges: resetUserStandardBadges,
  loadUserAllBadges: loadUserAllBadges,
  loadUserAllBadgesSuccess: loadUserAllBadgesSuccess,
  loadUserAllBadgesError: loadUserAllBadgesError,
  resetUserAllBadges: resetUserAllBadges,
  loadUserRaceBadges: loadUserRaceBadges,
  loadUserRaceBadgesSuccess: loadUserRaceBadgesSuccess,
  loadUserRaceBadgesError: loadUserRaceBadgesError,
  resetUserRaceBadges: resetUserRaceBadges
};
exports["default"] = _default;
//# sourceMappingURL=actions.js.map